import * as React from "react";
import { Button, FormGroup, Form, FormControl } from "react-bootstrap"

import { navigateToRoute } from "../Component/navigation"
import { alleHandlingerEkstra } from "../Component/Handlinger";
import { entitetPath, IRouteComponent, FeltError, feltFeil } from "../domene"
import { appContext } from "../App/appContext"
import { setUrlParam, getUrlParam, hasUrlParam } from "../Component/url"

import Models = Gf.Web.Models;

const trim = (value: string) => value && value.trim() || null;

export const søkeknapp = () =>
    <Button type="submit" bsStyle="primary" onClick={(evt: React.MouseEvent<{}>) => {
        const sokefelt = (document.getElementById("sokefelt") as HTMLInputElement);
        const trimmed = trim(sokefelt.value);
        
        let url = appContext.getCurrentLocation();
        url = setUrlParam(url, "q", trimmed || undefined);
        navigateToRoute(url);
        evt.preventDefault();
        evt.stopPropagation();
    } }>Søk</Button>;

export const tømmeknapp = () =>
    <Button type="button" disabled={!hasUrlParam(appContext.getCurrentLocation(), "q")} bsStyle="default" onClick={(evt: React.MouseEvent<{}>) => {
        const sokefelt = (document.getElementById("sokefelt") as HTMLInputElement);
        sokefelt.value = "";
        let url = appContext.getCurrentLocation();
        url = setUrlParam(url, "q", undefined);
        navigateToRoute(url);
    } }>Tøm</Button>;

export function sokeForm(
    handlinger: Models.HandlingDefinisjon[],
    handler: IRouteComponent,
    placeholder: string, 
    parameterHenter?: (handlingType: Models.HandlingType) => string | undefined): JSX.Element {
    const url = appContext.getCurrentLocation();
    const query = getUrlParam(url, "q");
    return <Form>
               { alleHandlingerEkstra(handlinger, handler, [søkeknapp(), tømmeknapp()], parameterHenter) }
               <FormGroup>
                   <FormControl id="sokefelt"
                                type="text"
                                placeholder={placeholder}
                                defaultValue={query}/>
               </FormGroup>
           </Form>;
}


// WEBPACK FOOTER //
// ./Scripts/React/Component/sok.tsx